import 'babel-polyfill'

import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

// localStorage shim (useful for iOS private browsing)
import storage from 'local-storage-fallback'
window.storage = storage

import Vue from 'vue'

import Bugsnag from '@bugsnag/js'
import bugsnagVue from 'bugsnag-vue'

import VueOnsen from 'vue-onsenui'

import axios from 'axios'

import { v4 as uuidv4 } from 'uuid'

import queryString from 'query-string'

import moment from 'moment'

import smoothscroll from 'smoothscroll-polyfill'

import defaults from 'lodash.defaults'

import { default as makeRouter } from './router'

import AlertComponent from './components/fragments/alert.vue'
import SetTitleComponent from './components/fragments/title.vue'

import BaseComponent from './components/base.vue'

import GtcButtonComponent from './components/fragments/gtc_button.vue'

import currency from 'currency.js'
window.currency = currency

// Polyfills
smoothscroll.polyfill()

// Set device ID
if (storage.getItem('deviceId') == null) {
    storage.setItem('deviceId', uuidv4())
}

// Detect testing
window.automated_testing = 'Cypress' in window

// Placeholders
let store = null

// Check that env is set
if (!window.env) {
    throw new Error('no env.js file!')
}

// Set env defaults
const default_config = {
    base_url: 'http://api.goodeats.test/api/',
    jwt_refresh_min: 10,
    bugsnag_key: null,
    release_stage: 'staging',
    stripe_pk: null,
    environment: 'dev',
    google_maps_key: null,
    google_maps_version: 'quarterly',
    google_client_key:  null,
    facebook_app_id:  null,
    google_analytics_tracking_id: null,
    paypal_env: 'sandbox',
    http_retry_interval_seconds: 10,
    http_retry_max_attempts: 6,
    product_expand_client_ids: [],
}
window.env = defaults(window.env, default_config)

const IS_DEV = env.environment != 'prod'

// Allow code injection (eg from automated tests)
if (window.before_start) {
    console.log('executing before_start')
    window.before_start(window)
}

// Load facebook SDK
if (window.env.hasOwnProperty('facebook_app_id')){
    window.fbAsyncInit = function() {
        FB.init({
            appId: window.env.facebook_app_id,
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v3.0'
        });

        console.log('facebook init complete');
    };

    (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
} else {
    console.error('no facebook_app_id in env')
}

// Init gapi auth2 once the script has loaded
window.gapiInit = () => {
    gapi.load('auth2', function() {
        console.log('gapi auth2 loaded')
    })
}

// Strip trailing slash from base_url
if (env.base_url.substr(-1) === '/')
    env.base_url = env.base_url.substr(0, env.base_url.length - 1)

// Add live reload script if required
if (env.environment != 'prod'){
    const el = document.createElement('script')
    el.setAttribute('src', 'http://localhost:35731/livereload.js')
    document.body.appendChild(el)
}

// Define HTTP function
const http = function (method, url, data, settings, silent = false) {

    settings = settings || {}
    data = data || false

    const axios_settings = settings
    axios_settings['method'] = method

    axios_settings['url'] = url
    if (data && method.toLowerCase() == 'get')
        axios_settings['params'] = data
    else if (data)
        axios_settings['data'] = data

    axios_settings['paramsSerializer'] = (params) => {
        return queryString.stringify(params, {arrayFormat: 'bracket'})
    }

    // Set headers
    axios_settings.headers = axios_settings.headers || {}
    const token = storage.getItem('token')
    if (token != null) {
        axios_settings.headers['Authorization'] = 'Bearer ' + token
    }

    if (store != null) {
        const device_id = store.getters.deviceId
        if (device_id != null) {
            axios_settings.headers['Device-Id'] = device_id
        }
    }

    axios_settings.headers['Referer-Complete'] = window.location.href

    axios_settings.headers['Client-Version'] = window.version || ''

    return new Promise((resolve, reject) => {

        // We're loading!
        if (silent == false)
            store.commit('setLoading')

        axios(axios_settings)
            .then(function (response) {

                // No longer loading
                if (silent == false)
                    store.commit('setLoading', false)

                // All good!
                resolve(response)
            })
            .catch(function (error) {

                // No longer loading
                if (silent == false)
                    store.commit('setLoading', false)

                // Logout due to token expired
                if (error.response &&
                    error.response.data &&
                    error.response.data.message &&
                    error.response.data.message == 'token_expired') {

                    App.logout()
                }

                // Logout due to token provided, maybe signed out
                // from another session?
                if (error.response &&
                    error.response.data &&
                    error.response.data.error &&
                    error.response.data.error == 'token_not_provided') {

                    App.logout()
                }

                reject(error)
            })
    })
}

// Store for global data
const App = {
    networkRetryDelay() {
        return window.env.http_retry_interval_seconds * 1000
    },
    maxRetryAttemptsReached(attempt) {
        // Return whether attempt is a multiple of the max attempts
        return window.env.http_retry_max_attempts == 0 || attempt % window.env.http_retry_max_attempts == 0
    },
    getToken: function () {
        return storage.getItem('token')
    },
    refreshTimer: null,
    startRefreshTimer: function () {

        // Refresh access token async, doesn't matter how fast this happens
        this.refreshTimer = setInterval(() => {

            console.log('refreshed timer ticked')

            if (store.getters.user == null || this.getToken() == null)
                return

            this.refresh()
                .then(() => {

                })
                .catch(error => {
                    console.error(error)
                    store.commit('logout')
                })
        }, 1000 * 60 * env.jwt_refresh_min)
    },
    refresh: function () {
        console.log('refreshing token')
        return new Promise((resolve, reject) => {
            this.http.post('/jwt/refresh', {}, {}, true)
                .then(response => {
                    console.log('refreshed access token')
                    store.commit('refreshToken', {
                        token: response.data.token,
                        user: response.data.user
                    })
                    resolve()
                })
                .catch(error => {
                    console.error('failed to refresh access token', error)
                    store.commit('logout')
                    reject(error)
                })
        })
    },
    focus: function (element) {

        // Don't focus on mobile to prevent the
        // keyboard popping up
        if (document.body.clientWidth < 768)
            return

        element.focus()
    },
    http: {
        get: (url, data, settings) => http('get', url, data, settings),
        post: (url, data, settings) => http('post', url, data, settings),
        patch: (url, data, settings) => http('patch', url, data, settings),
        delete: (url, data, settings) => http('delete', url, data, settings),
    },
    errorIsHttp(error) {
        // axios errors include the request as a 'request' property on the error object
        return error != null && error.request != null
    },
    errorIsHttpWithoutResponse(error) {
        // Determine if the request failed (no response). Treat error.response (no response, occurs in xhr) and
        // error.response.data (no response, mocked via testing) as the same.
        return this.errorIsHttp(error) && (error.response == null || error.response.data == null)
    },
    getResponseErrorMessage(error) {

        // Error present (should always be the case)
        if (error) {

            // Has response, return error message from backend
            if (error.response && error.response.data && error.response.data.message) {
                return error.response.data.message
            }

            // Network error (no response)
            if (error.response == null) {
                return 'A network error occurred - please ensure you have internet access and try again.'
            }

            // Error object message
            return error.message
        }

        // Other error
        return 'An unexpected error occurred - please try again.'
    },
    openPhone(phone_no) {
        window.open('tel:' + phone_no.replace(/\s/g, ''), '_blank');
    },
    openMap(address) {
        const address_str = Array.isArray(address) ? address.join(', ') : address
        const map_url = 'https://www.google.co.uk/maps/?q=' + encodeURIComponent(address_str)
        window.open(map_url, '_blank', 'location=yes')
    },
    openEmail(email) {
        window.open('mailto:' + email)
    },
    openLink(link) {
        if (link == null || link.length == 0) {
            return
        }

        window.open(link, '_blank', 'noopener')
    },
    homeRoute: function () {
        if (store.getters.embed.enabled) {
            return {name: 'Menu', outlet_slug: store.getters.embed.outlet_slug}
        } else {
            return {name: 'Outlets'}
        }
    },
    frameParentUrl: function () {
        try {
            if (window !== window.parent)
                return document.referrer
        } catch (e) {

        }
        return null
    },
    trackFbEvent: function (event = 'PageView', extra = {}) {

        try {
            // Check DNT
            if (navigator.doNotTrack == "1") {
                console.warn('Facebook Tracking Pixel disabled due to DNT')
                return
            }

            // Stop if no current outlet
            if (store.getters.outlet == null || store.getters.outlet.tracking.fb_tracking_pixel_id == null)
                return

            const id = store.getters.outlet.tracking.fb_tracking_pixel_id
            if (id == null || id.length == 0)
                return

            const args = {
                id,
                ev: event,
                // Add a random value to make this request unique
                reqId: uuidv4(),
            }

            // Add extra args with cd[key] syntax
            Object.entries(extra).forEach((entry) => args[`cd[${entry[0]}]`] = entry[1])

            // Build URL
            const params = queryString.stringify(args)
            const img_url = `https://www.facebook.com/tr?${params}`

            // Append img to body
            const img = document.createElement('img')
            img.src = img_url
            img.onerror = () => console.error('failed to load facebook pixel')
            document.getElementById('fb-tracking-container').appendChild(img)

            console.log('Facebook Tracking Pixel Request', args)
        } catch (e) {
            console.error('facebook Tracking Pixel error', e)
        }
    },
    objectCopyProperties(object, properties) {
        const out = {}
        properties.forEach(property => out[property] = object[property])
        return out
    },
    formatDateRequest(date) {

        if (date == null) {
            return null
        }

        return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    redirectToOrder(data, extra={}) {

        let route_name = 'Order'
        let route_params = Object.assign({}, extra)

        // Redirect to multi-vendor page
        if (data.sale_group_id != null) {
            route_params.sale_group_id = data.sale_group_id
            route_name = 'MultiOrder'
        }
        // Redirect to single order page
        else {
            route_params.sales_id = data.sale_id
        }

        router.replace({ name: route_name, params: route_params })
    },
}

// Init analytics
const analytics_plugins = []
if (env.google_analytics_tracking_id){
    analytics_plugins.push(
        googleAnalytics({
            trackingId: env.google_analytics_tracking_id,
            customDimensions: {
                client_id: 'dimension1',
                outlet_is_multivendor: 'dimension2',
                device_id: 'dimension3',
                local_order_id: 'dimension4',
            },
        })
    )
}

const analytics = Analytics({
    app: 'goodeats',
    plugins: analytics_plugins,
})

analytics.page()

App.analytics = analytics

// Init bugsnag
let bugsnag_client = null
if (env.hasOwnProperty('bugsnag_key')) {
    const before_send = report => {

        // Get user data
        let bugsnag_user = {
            device_id: store.getters.deviceId
        }
        let app_user = store.getters.user
        if (app_user) {
            bugsnag_user.id = app_user.id
            bugsnag_user.social_provider = app_user.social_provider
        }

        const outlet = store.getters.outlet
        if (outlet) {
            bugsnag_user.store_display_name = outlet.store_display_name
            bugsnag_user.outlet_slug = outlet.slug
            bugsnag_user.outlet_id = outlet.outlet_id
            bugsnag_user.outlet_name = outlet.outlet_name
            bugsnag_user.client_id = outlet.client_id
        }

        report.user = bugsnag_user
        report.metaData.order = store.getters.order
        report.metaData.request = { iframe_parent: App.frameParentUrl() }

        if (router && router.currentRoute) {
            report.context = router.currentRoute.name
        }
    }

    bugsnag_client = Bugsnag({
        apiKey: env.bugsnag_key,
        beforeSend: before_send,
        filters: [
            // General
            'password',
            'address',
            'user',
            'email',
            'phone',
            'Authorization',
            // Stripe payments
            'client_secret',
            'last4',
            'exp_month',
            'exp_year',
        ],
    })
    bugsnag_client.use(bugsnagVue(Vue))
    bugsnag_client.autoBreadcrumbs = false
    bugsnag_client.notifyReleaseStages = ['dev', 'prod', 'auto_test']
    bugsnag_client.app.version = window.version
    bugsnag_client.app.releaseStage = window.automated_testing ? 'auto_test' : env.release_stage

}

App.bugsnag = bugsnag_client

// Add global error reporting helper
App.logException = function(error, meta = {}, severity = 'error'){

    if (IS_DEV) {
        if (severity == 'warning') {
            console.warn(error, meta)
        } else {
            console.error(error, meta)
        }
    }

    // Serialise error data
    try {
        const previous_error = meta.error

        // Convert to object
        meta = JSON.parse(JSON.stringify(meta))

        // Handle previous errors as these do not serialise correctly
        if (previous_error && previous_error instanceof Error && Object.values(meta.error).length == 0)
            meta.error = JSON.parse(JSON.stringify(previous_error, ['name', 'message', 'stack']))

    } catch (e) { }

    if (bugsnag_client) {
        bugsnag_client.notify(error, {
            metaData: meta,
            severity
        })
    }
}

// Goodies login function
App.goodiesLogin = function() {

    if ('ReactNativeWebView' in window == false)
        return alert('No ReactNativeWebView found in window')

    const data = { type: 'click', message: 'login' }
    window.ReactNativeWebView.postMessage(JSON.stringify(data), '*')
    console.log('Sent Goodies login postMessage')
}

// Check params
const params = queryString.parse(location.search)
const IS_EMBED = 'embed_outlet' in params
const EMBED_OUTLET = params.embed_outlet
const OUTLET = params.outlet
const PRESET_LOCATION = params.location
const APP_EMBED = params.app_embed == 'true'
const TOKEN = 'token' in params ? params.token : null
const PRESET_FULFILMENT_TYPE = 'fulfilment' in params ? params.fulfilment : null
const PRESET_DISPLAY_LAYOUT_ID = 'display_layout' in params ? params.display_layout : null
const APP_MODE = 'mode' in params ? params.mode : null

// Reset localstorage, if required
if ('reset' in params){
    const reset = params.reset
    if (reset == 'all'){
        storage.clear()
        console.log('clearing all storage')
    } else{
        reset.split(',').forEach(key => {
            storage.removeItem(key)
            console.log('removed item from storage: ' + key)
        })
    }
}

// Import store
import { default as getStore } from './store'
store = getStore(App)

// Configure Axios
axios.defaults.baseURL = env.base_url

// Configure Vue
Vue.use(VueOnsen)

// Register global components
Vue.component('alert-component', AlertComponent)
Vue.component('set-title', SetTitleComponent)
Vue.component('gtc-button', GtcButtonComponent)

// Add filters
Vue.prototype.filters = {
    epoch: function(value){
        return moment(value).unix()
    },
    date: function(value, include_time=true, null_text='No date', include_day=false) {
        if (value == null)
            return null_text

        const format = (include_day ? 'ddd ' : '') + 'DD/MM/YYYY' + (include_time ? ' HH:mm' : '')
        return moment(value).format(format)
    },
    dateFormat(value, format){

        const time_format = 'HH:mm'
        const date_format = 'ddd DD/MM/YYYY'

        if (format == 'TIME')
            return moment(value).format(time_format)

        if (format == 'DATE')
            return moment(value).format(date_format)

        return moment(value).format(`${date_format} ${time_format}`)
    },
    dateRelative: function(value, default_value = 'Never'){
        if (value == null) {
            return default_value
        }
        return moment(value).from(moment())
    },
    dateNth: function(day){
        return moment().date(day).format('Do')
    },
    bool: function(value){

        if (value == null)
            return ''

        return value ? 'Yes' : 'No'
    },
    money: function(value, force_value, currency_symbol='£'){

        if (value == null)
            return ''

        if (value == 0 && !force_value)
            return 'Free'

        return currency_symbol + currency(value).toString()
    },
    percentage: function(value, dp=0) {

        if (value == null)
            return value

        return parseFloat(value).toFixed(dp) + '%'
    },
    toFixed: function(value, dp=2){
        return Number(value).toFixed(dp)
    },
    lines: function(value){

        if (value == null)
            return []

        return value.split("\n")
    },
    truncate: function(value, length_chars=50){

        if (value == null)
            return ''

        if (value.length <= length_chars)
            return value

        return value.substring(0, length_chars) + '…'
    },
    capitalise: function(value){

        if (typeof value !== "string"){
            return value
        }

        if (value == null || value.length <= 2)
            return value

        return value[0].toUpperCase() + value.slice(1)
    },
    pluralise: function(count, string, plural_string=null){
        if (count == 1)
            return string
        if (plural_string == null)
            plural_string = string + 's'

        return plural_string
    },
    roundUp: function(value){
        return Math.ceil(Number(value))
    },
    distance: function(value){
        return parseFloat(value)
    },
    noSpace: function(value){
        return value.replace(/\s/g,'')
    },
    cardDateFormat: function(value){
        return moment(value).format('MM / YY')
    }
}

const isiOS = () => (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream

const isSafari = () => 'safari' in window

const isAndroid = () => /(android)/i.test(navigator.userAgent)

const isChrome = () => navigator.userAgent.includes('Chrome')

// Add helpers
Vue.prototype.helpers = {
    unifyDate: function(date){

        if (date == null || date == '')
            return null

        return moment(date, ["YYYY-MM-DD", "DD/MM/YYYY"]).format('DD/MM/YYYY')
    },
    unifyDateTime: function(date){

        if (date == null || date == '')
            return null

        return moment(date, ["YYYY-MM-DDTkk:mm", "DD/MM/YYYY kk:mm"]).format('DD/MM/YYYY kk:mm')
    },
    editDate: function(date){

        if (date == null || date == '')
            return null

        return moment(date).format("YYYY-MM-DDTkk:mm")
    },
    hasPermission: function(user, permissions) {

        if (user == null)
            return false

        if (Array.isArray(permissions) == false)
            permissions = [permissions]

        const user_permissions = user.roles[0].permissions.map(p => p.slug)
        return user_permissions.some(p => permissions.includes(p))
    },
    last: function(item, list){
        return item === list[list.length - 1]
    },
    stringEmpty: function(string){
        return string == null || string.length == 0
    },
    deepCopy: function(data) {
        return JSON.parse(JSON.stringify(data))
    },
    dump: function(){
        const args = Array.from(arguments).map(arg => {
            if (typeof arg === 'object')
                return JSON.parse(JSON.stringify(arg))
            return arg
        })
        console.log(...args)
    },
    isiOS,
    isAndroid,
    paymentRequestName: function(include_web=true){

        if (isiOS() || isSafari())
            return 'Apple Pay'
        else if (isAndroid() || isChrome())
            return 'Google Pay'

        if (include_web)
            return 'Web payment'

        return null
    },
    outletPrepTimeShort: function(minutes){
        if (minutes == null)
            return null

        // Minutes
        if (minutes < 60)
            return `${minutes} mins`

        // Hours
        if (minutes == 60)
            return `1 hour`

        if (minutes < 24 * 60)
            return `${Math.ceil(minutes / 60)} hours`

        // Days
        if (minutes == 60 * 24)
            return `1 day`

        return `${Math.ceil(minutes / 60 / 24)} days`
    },
    round: function round(number, decimals) {
        return +(Math.round(number + "e+" + decimals)  + "e-" + decimals);
    },
    isPromise: function(obj) {
        return !!obj && typeof obj.then === 'function'
    },
}

// Hydrate store from localStorage
store.commit('initialiseStore')

store.commit('setEmbed', { enabled: IS_EMBED, outlet_slug: EMBED_OUTLET })

store.commit('setAppEmbed', APP_EMBED)

store.commit('setAppMode', APP_MODE)

let preset_fulfilment_type = null
 
if (PRESET_LOCATION || PRESET_FULFILMENT_TYPE) {
    try {
        preset_fulfilment_type = {}
        preset_fulfilment_type['type'] = PRESET_FULFILMENT_TYPE ? PRESET_FULFILMENT_TYPE.toUpperCase() : 'DROPOFF'
        if (PRESET_LOCATION) {
            if (preset_fulfilment_type['type'] == 'DROPOFF') {
                preset_fulfilment_type['dropoff_point'] = PRESET_LOCATION.split('|')[0]
                if (PRESET_LOCATION.includes('|'))
                    preset_fulfilment_type['dropoff_point_reference'] = PRESET_LOCATION.split('|')[1]
            } 

            if (preset_fulfilment_type['type'] == 'COLLECTION')
                preset_fulfilment_type['collection_point'] = PRESET_LOCATION
        }
        preset_fulfilment_type['display_layout_id'] = PRESET_DISPLAY_LAYOUT_ID
        preset_fulfilment_type['outlet_slug'] = OUTLET
    } catch (error) {
        App.logException(new Error('Failed to load preset fulfilment type.'), { error })
    }
}

if (preset_fulfilment_type) 
    store.commit('setPresetFulfilmentType', preset_fulfilment_type)

// Set token, if provided
if (TOKEN) {
    if (TOKEN == 'logout')
        store.commit('logout')
    else
        store.commit('setToken', TOKEN)
}


// Otherwise refresh token
if (store.getters.token != null)
    App.refresh()
        .catch(error => console.error('Failed to refresh token', error))

const router = makeRouter(IS_EMBED, store)

router.afterEach((to, from) => {
    if (bugsnag_client) {
        bugsnag_client.refresh()
    }
})

// Export internals for access in test
if (window.automated_testing) {
    window.store = store
    window.app = App
}

// Allow code injection (eg from Cypress)
if (window.after_start) {
    window.after_start(window)
    console.log('executed after_start')
}

new Vue({
    store,
    router,
    data : {
        'app' : App
    },
    template: '<BaseComponent/>',
    components: { BaseComponent },
    beforeCreate() {
        // Always use material theme
        this.$ons.platform.select('android')
    },
    mounted() {
        // Record whether the menu page was accessed directly. We'll change the menu page UI based on whether the user
        // navigated to the outlet directly (via URL) or indirectly (via outlet listing)
        try {
            if (router.currentRoute.name === 'Menu') {
                store.commit('setOrderLoadedDirectly', true)
            }
        } catch (error) {
            console.log('Mount error:', error)
        }

        // Redirect to processing page if we need to check the status of an in-flight order. This *must* be added to the
        // stack rather existing as the top level route, otherwise this will cause issues when watching the route
        // change.
        if (store.getters.order && store.getters.order.checkout_in_progress) {
            router.push({ name: 'Processing' })
        }
    },
    watch: {
        '$route'(to, from) {
            analytics.page()
        },
    }
}).$mount('#app')

// Allow configuring devtools from env
if (IS_DEV == false){
    Vue.config.devtools = true
    Vue.config.silent = false
}

// Load user from localStorage, if exists
App.startRefreshTimer()


// WEBPACK FOOTER //
// ./src/js/app.js